import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'gas-tag',
  templateUrl: './gas-tag.component.html',
  styleUrls: ['./gas-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasTagComponent {

  @Input()
  public label = '';

  @Input()
  public iconName = '';

  @Output('tagClicked')
  public tagClicked$ = new EventEmitter();

  @HostListener('click')
  public onClick() {
    this.tagClicked$.emit();
  }
}
